import { RouteObject } from 'react-router-dom';
import ProtectedRoute from './protectedRoute';
import AdminOrdersPage from '../pages/Admin/Orders/Index';
import AdminViewOrders from '../pages/Admin/Orders/View/Index';
import PrivateLayout from '../pages/Layouts/PrivateLayout/Index';

const adminRoutes: RouteObject[] = [
    {
        path: '/admin',
        element: <PrivateLayout />,
        children: [

            {
                path: 'orders',
                element: (
                    <ProtectedRoute>
                        <AdminOrdersPage />
                    </ProtectedRoute>
                ),
            },
            {
                path: 'orders/:orderId',
                element: (
                    <ProtectedRoute>
                        <AdminViewOrders />
                    </ProtectedRoute>
                ),
            },
        ],
    },
];

export default adminRoutes;
